import React, { useEffect, useRef } from 'react';

const get_cbid = () => {
	let em = document.getElementById("Cookiebot");
	if (!em) return null;
	let cbid = em.getAttribute("data-cbid");
	if (!cbid) return null;
	return cbid;
};

const using_cookiebot = () => !!get_cbid();

const CookiebotPage2 = (props) => {
	let ref = useRef();

	useEffect(() => {
		if (!ref.current) {
			console.log("NOT installing cookiebot");
			return;
		}

        // Add configuration script
        const configScript = document.createElement("script");
        configScript.id = "CookiebotConfiguration";
        configScript.type = "application/json";
        configScript.setAttribute("data-cookieconsent", "ignore");
        configScript.textContent = JSON.stringify({
            Frameworks: {
                IABTCF2: {
                    AllowedSpecialFeatures: []
                }
            }
        }).replace(/\u00a0/g, " ").replace(/&nbsp;/g, " ");
        ref.current.appendChild(configScript);

        console.log("INSTALLING cookiebot");

		const script = document.createElement("script");
		script.id = "CookieDeclaration";
		script.src = "https://consent.cookiebot.com/"+props.cbid+"/cd.js";
		script.type = "text/javascript";
		script.async = "async";

		ref.current.innerHTML = "";
		ref.current.appendChild(script);

        // Add event listener for Cookiebot dialog display
        window.addEventListener("CookiebotOnDialogDisplay", function () {
            const LIAllowedVendors = [32, 50, 755];
            const LIAllowedPurposes = [2, 7, 9, 10];
            const IABVendorLI = document.querySelectorAll(".CybotCookiebotDialogBodyIABButtonVendorsLegitimateInterestSelection");
            const IABPurposesLI = document.querySelectorAll(".CybotCookiebotDialogBodyIABButtonPurposesLegitimateInterestSelection");
            const IABLI = [...IABVendorLI, ...IABPurposesLI];
            for (let i of IABLI) {
                i.checked = LIAllowedVendors.includes(parseInt(i.dataset.iabvendorid)) || LIAllowedPurposes.includes(parseInt(i.dataset.iabpurposeid)) ? true : false;
            }
        });

		return () => {
            configScript.remove();
            script.remove();
            window.removeEventListener("CookiebotOnDialogDisplay", () => {});
        };
	}, [ref]);

	return <div ref={ref}/>
};


const CookiebotPage = (props) => {
	let cbid = get_cbid();
	if (!cbid) return null;
	return <CookiebotPage2 cbid={cbid}/>
};

export {
	using_cookiebot,
	CookiebotPage,
}


// WEBPACK FOOTER //
// ./src/c/Cookiebot.js